import Toggle from '@/components/Toggle';
import DividerV2 from '@/components/v2/DividerV2';
import { useAnalytics } from '@/hooks/useAnalytics';
import confirmDialog from '@/lib/confirmDialog';
import sendToast from '@/lib/sendToast';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import selectors from '@/redux/selectors/selectors';
import workflowActions from '@/screens/workflows/redux/actions/workflowActions';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors';
import { useSelector } from 'react-redux';

const WorkflowStatusButton = () => {
  const workflowId = useArgSelector(selectors.param, 'workflowId');
  const canEdit = useArgSelector(selectors.permission, 'workflow:edit');
  const workflowIsActive = useSelector((state) => workflowScreenSelectors.activeWorkflowMetadata(state)?.isActive);
  const workflowLastSuccessfulFinishedOn = useSelector((state) => workflowScreenSelectors.activeWorkflow(state)?.lastSuccessfulFinishedOn);
  const publishedWorkflowVersion = useSelector((state) => selectors.workflowMetadataById(state, workflowId)?.publishedVersion);
  const isTutorial = useSelector((state) => !!workflowScreenSelectors.activeWorkflowMetadata(state)?.tutorialSlug);
  const { trackEvent } = useAnalytics();
  const toggleWorkflowIsActive = async () => {
    if (!canEdit) {
      sendToast({ message: 'You do not have permission to perform this action.' });
      return;
    }

    const newValue = !workflowIsActive;
    if (newValue && !workflowLastSuccessfulFinishedOn && !isTutorial) {
      const confirm = await confirmDialog({
        title: 'Are you sure you want to activate?',
        message: "This workflow has never been run. It's highly recommended you test running this workflow before activating it."
      });

      if (!confirm || confirm === 'cancel') {
        trackEvent('workflow-attemptToggleActiveNeverRun');
        return;
      }
    }
    trackEvent('workflow-toggleActive');
    workflowActions.setMetadata('isActive', newValue);
  };

  if (!publishedWorkflowVersion || workflowIsActive === undefined) {
    return null;
  }

  return (
    <>
      <div className="workflow-status-button" onClick={toggleWorkflowIsActive} data-active={workflowIsActive} role="button" data-title={workflowIsActive ? 'Deactivate Workflow' : 'Activate Workflow'}>
        <Toggle size="xs" active={workflowIsActive} onChange={toggleWorkflowIsActive} />
        {workflowIsActive ? 'Active' : 'Inactive'}
      </div>
      <DividerV2 mode="vertical" />
    </>
  );
};

export default WorkflowStatusButton;
